import { render, staticRenderFns } from "./LiftAreaAuthority.vue?vue&type=template&id=649fbe7c&scoped=true&"
import script from "./LiftAreaAuthority.vue?vue&type=script&lang=js&"
export * from "./LiftAreaAuthority.vue?vue&type=script&lang=js&"
import style0 from "./LiftAreaAuthority.vue?vue&type=style&index=0&id=649fbe7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649fbe7c",
  null
  
)

export default component.exports